import React from 'react';

const StatusButton = ({ status }) => {
  const STATUS_MAP = {
    active: { text: 'Active', color: 'active' },
    approved: { text: 'Active', color: 'active' },
    new: { text: 'Active', color: 'active' },
    inactive: { text: 'Inactive', color: 'not-active' },
    blocked: { text: 'Blocked', color: 'not-active' },
    redeem: { text: 'Redeem', color: 'status-indebt' },
    success: { text: 'Success', color: 'active' },
    pending: { text: 'Pending', color: 'warning' },
    'not-active': { text: 'Terblokir', color: 'not-active' },
    available: { text: 'Ready', color: 'active' },
    booked: { text: 'In Use', color: 'warning' },
    locked: { text: 'In Repair', color: 'not-active' },
    requested: { text: 'Requested', color: 'warning' },
    paid: { text: 'Belum Diproses', color: 'status-paid' },
    completed: { text: 'Sedang Berjalan', color: 'status-completed' },
    finished: { text: 'Selesai Sewa', color: 'status-finished' },
    checkout: { text: 'Konfirmasi Order', color: 'status-checkout' },
    cancelled: { text: 'Batal Sewa', color: 'status-cancelled' },
    failed: { text: 'Failed', color: 'status-cancelled' },
    reconfirmation: { text: 'Re-Konfirmasi', color: 'status-reconfirmation' },
    full: { text: 'Lunas', color: 'status-full' },
    half: { text: 'DP', color: 'status-half' },
    rejected: { text: 'Rejected', color: 'status-cancelled' },
    created: { text: 'Baru', color: 'status-completed' },
    transfered: { text: 'Selesai', color: 'status-finished' },
    on_debt: { text: 'Hutang', color: 'status-indebt' },
    processed: { text: 'Diproses', color: 'status-processed' },
    waiting_approval: { text: 'Waiting Approval', color: 'status-approval' },
    reviewing_identity: { text: 'Review Identity', color: 'status-approval' },
    request_cancel: { text: 'Request Cancel', color: 'warning' },

    // Admin task
    baru: { text: 'Baru', color: 'status-completed' },
    ditolak: { text: 'Ditolak', color: 'status-cancelled' },
    selesai: { text: 'Selesai', color: 'status-finished' },

    // Driver task
    open: { text: 'Belum Dapat Driver', color: 'status-open' },
    'booked-task': { text: 'Sudah Dapat Driver', color: 'status-booked' },
    running: { text: 'Sedang Berjalan', color: 'status-running' },
    finish: { text: 'Selesai', color: 'status-completed' },
    cancel: { text: 'Batal', color: 'status-cancelled' },
    on_pick_up_location: { text: 'Menjemput Penumpang', color: 'status-running' },
    transporting_passenger: { text: 'Mengantar Penumpang', color: 'status-running' },

    // Withdraw
    REQUEST: { text: 'Belum Diproses', color: 'status-request' },
    COMPLETED: { text: 'Berhasil', color: 'status-completed' },
    PROCESSED: { text: 'Diproses', color: 'status-approval' },
    REJECTED: { text: 'Ditolak', color: 'status-cancelled' },

    // Refund
    'refund-transfered': { text: 'Selesai', color: 'status-completed' },
    'refund-rejected': { text: 'Batal', color: 'status-cancelled' },
    'refund-processed': { text: 'Diproses', color: 'status-indebt' },
    'refund-created': { text: 'Belum Diproses', color: 'status-processed' },
    'refund-request_change': { text: 'Request Edit', color: 'status-indebt' },

    // Verification driver
    verification: { text: 'Verifikasi', color: 'status-approval' },
  };

  const getStatus = () => {
    if (typeof status === 'boolean') {
      return status
        ? { text: 'Applied', color: 'status-completed' }
        : { text: 'Not Applied', color: 'status-processed' };
    }

    return STATUS_MAP[status] || { text: status, color: 'status-default' };
  };

  return (
    <div className={`btn-status ${getStatus().color}`}>
      <p>{getStatus().text}</p>
    </div>
  );
};

export default StatusButton;
